import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject, combineLatest, firstValueFrom, Observable } from 'rxjs';
import { CustomerService } from '../../services/customer.service';
import { CustomerType, FirestoreCustomer } from '@jessie/commons';
import { EmptyComponent } from '../../components/empty/empty.component';
import { CustomerListEntryComponent } from './customer-list-entry/customer-list-entry.component';
import { AsyncPipe, NgClass } from '@angular/common';
import { DropdownItemComponent } from '../../components/dropdown-minimal-menu/dropdown-item/dropdown-item.component';
import { TailwindButtonDirective } from '../../components/button/tailwind-button.directive';
import { DropdownButtonComponent } from '../../components/dropdown-minimal-menu/dropdown-button/dropdown-button.component';
import { DropdownMinimalMenuComponent } from '../../components/dropdown-minimal-menu/dropdown-minimal-menu.component';
import { HeaderMetaActionComponent } from '../../components/container/header-meta-action/header-meta-action.component';
import { ContainerComponent } from '../../components/container/container.component';
import { Dialog } from '@angular/cdk/dialog';
import {
  CustomerSlideOverComponent,
  CustomerSlideOverInput,
} from './customer-slide-over/customer-slide-over.component';
import { TailwindInputDirective2 } from '../../components/input/tailwind-input2.directive';
import { NgIconWrapperComponent } from '../../components/icons/ng-icon-wrapper/ng-icon-wrapper.component';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  imports: [
    ContainerComponent,
    HeaderMetaActionComponent,
    DropdownMinimalMenuComponent,
    DropdownButtonComponent,
    TailwindButtonDirective,
    DropdownItemComponent,
    CustomerListEntryComponent,
    NgClass,
    EmptyComponent,
    AsyncPipe,
    TailwindInputDirective2,
    NgIconWrapperComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomersComponent {
  customers$: Observable<FirestoreCustomer[]>;

  filter = new BehaviorSubject<string>('');

  filteredCustomers$: Observable<FirestoreCustomer[]>;

  constructor(
    private customerService: CustomerService,
    private router: Router,
    @Inject(Dialog) private dialog: Dialog
  ) {
    this.customers$ = this.customerService.getAllCustomers();
    this.filteredCustomers$ = combineLatest([this.customers$, this.filter]).pipe(
      map(([customers, filter]) =>
        customers.filter((customer) =>
          customer.data.displayName.toLowerCase().includes(filter.toLowerCase())
        )
      )
    );
  }

  async createCustomer(type: CustomerType): Promise<void> {
    const dialogRef = this.dialog.open<string, CustomerSlideOverInput, CustomerSlideOverComponent>(
      CustomerSlideOverComponent,
      { data: { customerType: type } }
    );
    const id = await firstValueFrom(dialogRef.closed);
    if (id) {
      this.router.navigate(['/customer/', id]);
    }
  }

  editCustomer(customer: FirestoreCustomer) {
    this.dialog.open<string, CustomerSlideOverInput, CustomerSlideOverComponent>(
      CustomerSlideOverComponent,
      { data: { customer: customer } }
    );
  }

  setFilterValue(event: any) {
    if (event.target) {
      this.filter.next(event.target.value ?? '');
    }
  }

  protected readonly console = console;
}
